var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 106,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 55,
    r: 51,
    fill: "#12658E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#232F3C",
    d: "M77 54.5 37.25 77.45v-45.9L77 54.5Z"
  })));
};
export default SvgPlay;